<template>
	<Row :gutter="[16, 8]">
		<Col :span="18" :offset="0">
			<div class="padding-lg-x">
				<StatsChartTitleWithDescription
					titleKey="gnss-visibility.chartTitle"
					descriptionKey="gnss-visibility.chartTitleTooltip"
					titleClass="pd-md-top"
				/>
				<TimeSeriesChart v-if="mountpointsSelected.length > 0" :isLoading="isLoading" :series="series" :options="chartOptions" :height="500" />
				<EmptyChartFiltersMessage v-else messageKey="gnss-visibility.mountpointsPlaceholder.baseStation" />
			</div>
		</Col>
		<Col :span="6" :offset="0">
			<VerticalLayout>
				<Card :bordered="false">
					<VerticalLayout>
						<div class="flex-wrapper">
							<div class="flex-grow">
								{{ $t('gnss-visibility.mountpointsLabel.baseStation') }}
							</div>
							<Button size="small" @click="onSelectAllLocal">
								{{ $t('gnss-visibility.mountpointsSelectAllLabel') }}
							</Button>
						</div>
						<Select
							class="width-100"
							v-model:value="mountpointsSelected"
							mode="multiple"
							:allowClear="true"
							:options="mountpointsOptions"
							:placeholder="$t('gnss-visibility.mountpointsPlaceholder.baseStation')"
							@change="setSubnetworkOnMountpointsChange"
						/>
						<SubNetworkSelect
							ref="subNetworkSelect"
							:onChange="setMountpointsForSubnetwork"
							:allowClear="true"
						/>
						<GnssSelect ref="gnssSelectRef" :onChange="gnssVisibilityTimeSeriesGet" />
						<DateRangeChooser v-if="showDateRangeChooser" v-model="datesRange" @change="gnssVisibilityTimeSeriesGet" />
					</VerticalLayout>
				</Card>
			</VerticalLayout>
		</Col>
	</Row>
</template>

<script>
import { toRef } from 'vue';
import { Row, Col, Card, Select, Button } from 'ant-design-vue';

import { useBaseStationsStore } from '@/stores/baseStations';
import { useGnssVisibilityChartGroup } from '@/utils/useGnssVisibilityChartGroup';
import { useSubNetworkMountpointsFilter } from '@/utils/useSubNetworkMountpointsFilter';

import VerticalLayout from '@/components/common/VerticalLayout';
import GnssSelect from '@/components/common/controls/GnssSelect.vue';
import DateRangeChooser from '@/components/common/DateRangeChooser';
import SubNetworkSelect from '@/components/common/controls/SubNetworkSelect.vue';

import EmptyChartFiltersMessage from '@/components/charts/EmptyChartFiltersMessage';
import TimeSeriesChart from '@/components/stats/TimeSeriesChart';
import StatsChartTitleWithDescription from '@/components/stats/StatsChartTitleWithDescription.vue';


export default {
	components: {
		Row, Col, Card, Select, Button,
		VerticalLayout, GnssSelect, DateRangeChooser, TimeSeriesChart, EmptyChartFiltersMessage, SubNetworkSelect,
		StatsChartTitleWithDescription,
	},
	props: {
		initMountpointSelected: {
			type: String,
			required: false,
		},
		showDateRangeChooser: {
			type: Boolean,
			required: false,
			default: true,
		},
		minDate: {
			type: Date,
			required: false,
		},
		maxDate: {
			type: Date,
			required: false,
		},
	},
	setup(props) {
		const baseStationsStore = useBaseStationsStore();
		const initMountpointSelectedRef = toRef(props, 'initMountpointSelected');
		const {
			isLoading,
			mountpointsOptions,
			mountpointsSelected,
			gnssSelectRef,
			onSelectAll,
			clearSelectedMountpoints,
			datesRange,
			series,
			chartOptions,
			gnssVisibilityTimeSeriesGet,
		} = useGnssVisibilityChartGroup({
			props,
			apiMode: 'baseStation',
			getMountpointsOptions: () => baseStationsStore.mountpointsSelectOptions,
			initMountpointSelectedRef: initMountpointSelectedRef,
		});
		const {
			subNetworkSelect,
			setMountpointsForSubnetwork,
			setSubnetworkOnMountpointsChange,
		} = useSubNetworkMountpointsFilter(mountpointsSelected, gnssVisibilityTimeSeriesGet);
		const onSelectAllLocal = () => {
			onSelectAll();
			setSubnetworkOnMountpointsChange();
		}
		return {
			isLoading,
			mountpointsOptions,
			mountpointsSelected,
			gnssSelectRef,
			onSelectAllLocal,
			clearSelectedMountpoints,
			datesRange,
			series,
			chartOptions,
			gnssVisibilityTimeSeriesGet,
			subNetworkSelect,
			setMountpointsForSubnetwork,
			setSubnetworkOnMountpointsChange,
		};
	},
}
</script>
